import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Login from "../components/Admin Pages/Login";
import Warning from "../components/Warning";
import Banner from "../components/Banner";

const LoginPage = () => {
  return (
    <>
      <Banner />

      <section className="hidden lg:block">
        <Navbar />
        <Warning />
      </section>
      <section className="block lg:hidden">
        <Sidebar />
      </section>
      <Login />
      <Footer />
    </>
  );
};

export default LoginPage;
